import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const WhyChooseUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="bg-blue-950 text-sky-400 pt-8 px-4 sm:px-8 lg:px-16 bg-cover bg-center min-h-screen">
      {/* Overlay */}
      <div className="bg-blue-950 bg-opacity-90 min-h-screen py-10">

        {/* Founder Section */}
        <section className="max-w-6xl mx-auto mb-16">
          <h2
            className="text-3xl sm:text-4xl font-bold text-center mb-8"
            data-aos="fade-up"
          >
            Meet Our Founder
          </h2>

          <div
            className="flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-12"
            data-aos="fade-up"
          >
            <img
              src="/Founder.png"
              alt="Founder"
              className="w-64 sm:w-72 md:w-80 lg:w-96 h-auto rounded-2xl shadow-2xl object-contain mx-auto"
            />

            <div className="text-center lg:text-left">
              <h3 className="text-2xl font-semibold mb-2">
                Mr. Vishal Patil
              </h3>

              <p className="text-white text-lg leading-relaxed">
                With a vision to empower businesses through robust IT
                solutions, Mr. Vishal Patil founded Sairaj Infotech with a
                focus on reliability, innovation, and excellence. His
                leadership drives our commitment to quality and customer
                success.
              </p>
            </div>
          </div>
        </section>

        {/* Certificates Section */}
        <section className="max-w-7xl mx-auto mb-16">
          <h2
            className="text-3xl sm:text-4xl font-bold text-center mb-8"
            data-aos="fade-up"
          >
            We Awarded
          </h2>

          <div
            className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6"
            data-aos="fade-up"
          >
            {[
              "lenovo.jpg",
              "DELL.jpeg",
              "HP.jpeg",
              "QuickHeal.jpeg",
            ].map((cert, index) => (
              <img
                key={index}
                src={`/certificates/${cert}`}
                alt={`Certificate ${index + 1}`}
                className="w-auto h-auto object-contain hover:grayscale-0 transition"
              />
            ))}
          </div>
        </section>

      </div>
    </div>
  );
};

export default WhyChooseUs;